import React from "react";
import DataTable from "../../../datatable";
import { useState, useEffect } from "react";
import {
  invoiceStatusConfig,
  PAGINATION_DEFAULT,
} from "../../../../utils/constants";
import { useParams } from "react-router-dom";
import Button from "../../../button";
import { useHistory } from "react-router-dom";
import {
  useDeleteInvoice,
  useGetInvoicesByCustomer,
} from "../../../../redux/spend-management/invoice/hook";

export const CustomerInvoicesTab = () => {
  useEffect(() => {}, []);

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: "",
  });
  const { id } = useParams();
  const history = useHistory();

  const { data: invoices } = useGetInvoicesByCustomer(
    id,
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  );

  const { mutateAsync: deleteInvoice } = useDeleteInvoice();

  const tableConfig = {
    // title: 'Bonus Management',
    headers: [
      "Invoice Date",
      "Customer Name",
      "Mobile",
      "Due Date",
      "Invoice #",
      "Total Amount",
      "Status",
      "Due Status",
    ],
    keys: [
      "invoice_date",
      "customer_name",
      "customer_mobile",
      "invoice_due_date",
      "invoice_number",
      "total_amount",
      "status",
      "due_status",
    ],
    mobileHeader: {
      left: {
        title: "Customer Name",
        key: "customer_name",
      },
      right: {
        title: "Total Amount",
        key: "total_amount",
      },
    },
  };

  const actionConfig = [
    {
      name: "View",
      color: "orange",
      action: (id) => {
        let index = invoices.data.findIndex((item) => item.id === id);
        history.push(`/customers/invoice?invoiceId=${invoices.data[index].id}`);
      },
    },
    {
      name: "Delete",
      color: "red",
      action: (id) => {
        let index = invoices.data.findIndex((item) => item.id === id);
        deleteInvoice(invoices.data[index].id);
      },
    },
  ];

  return (
    <div className="flex flex-col bg-white rounded">
      <div className="flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3">
        <div className="md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full">
          Invoices
        </div>
        <div className="flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full">
          <div className="md:w-fit w-[100%]">
            <Button
              text="New Invoice"
              type="submit"
              theme="primary"
              className="flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center"
              textClass={"!text-[11px]"}
              leftIcon={"add"}
              onClick={() => {
                history.push(`/customers/invoice`);
              }}
            />
          </div>
        </div>
      </div>
      <hr className="divider mt-2 mb-1" />
      <DataTable
        data={invoices}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        statusConfig={invoiceStatusConfig}
        updatePagination={(data) => setPagination(data)}
        noCheck={true}
        computedActions={true}
      />
    </div>
  );
};
